import React, { useEffect, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { Banners } from "@superloop-bnsc/react-portal";
import Main from "../main";
import Header from "../section/header";
import Footer from "../section/footer";
import LoginControl from "../../controls/login";
import MfaPanel from "./mfa";
import StandardTerms from "../standard-terms";
import PrivacyPolicy from "../portal/privacy-policy";
import config from "../../config";

const  LoginPage =  ({currentUser}) =>{
  const [showMfa, setShowMfa] = useState(false);
  const [mfaMethod, setMfaMethod] = useState(null);
  const [allowedOptions, setAllowedOptions] = useState(["admin-generated-otp"]);
  const [userData, setUserData] = useState(null);
  const [mfa, setMfa] = useState(null);
  const [showTerm, setTerm] = useState(false);
  const [showPolicy, setPolicy] = useState(false);

  useEffect(() => {
    if (userData) {
      setShowMfa(false);
    }
  }, []);

  return (
    <Main>
      {showTerm && <StandardTerms onClose={() => setTerm(false)} />}
      {showPolicy && <PrivacyPolicy onClose={() => setPolicy(false)} />}
      <Header />
      <div className="vw-outside-pages">
        {location?.search?.indexOf("EOVERLIMIT") > -1 ? (
          <Row
            className="vw-alert red no-gutters"
            onClick={() =>
              (window.location.href = `${process.env.PORTAL_URL}/`)
            }
          >
            <Col>
              {
                "You have reached the data limit associated with your plan. Click here to assign a new plan."
              }
            </Col>
          </Row>
        ) : undefined}
        <div className="vw-landing">
          <div className="section-1">
            <Row className="vw-fs">
              <Banners isPortal={false} externalUrl={config.externalUrl} portalUrl={config.portal} />
              <Col xs={12} md={12} lg={4} className="vw-fs-section">   
                <Modal
                  show={showMfa && userData}
                  className="login-mfa-panel-modal"
                >
                  <MfaPanel
                    mfaMethod={mfaMethod}
                    setShowMfa={setShowMfa}
                    mfa={mfa}
                    allowedOptions={allowedOptions}
                    setMfaMethod={setMfaMethod}
                    userData={userData}
                    setUserData={setUserData}
                  />
                </Modal>
                <div className="sub-section-2">
                  {!showMfa && (
                    <div className="vw-section-panel">
                      <Row>
                        <Col xs={12} className="vw-title">
                          {"Login to your account"}
                        </Col>
                      </Row>
                      <LoginControl
                        authUrl={process.env.AUTH_URL}
                        portalUrl={process.env.PORTAL_URL}
                        apiUrl={process.env.BACKEND_URL}
                        setMfa={setMfa}
                        setShowMfa={setShowMfa}
                        setAllowedOptions={setAllowedOptions}
                        setUserData={setUserData}
                      />
                    </div>
                  )}
                </div>
              </Col> 
            </Row>
          </div>
          <Footer setTerm={setTerm} setPolicy={setPolicy} />
        </div>
      </div>
    </Main>
  );
};

export default LoginPage;
